import styled from 'styled-components'

import { Divider } from '@reveni-io/reveni-ui'

export const CustomDivider = styled(Divider)`
  margin-top: ${props => props.theme.spacing.sp24};
`
